export const round = (n: any): any => Math.round(n);
